import RegistrationContainer from "../../Component/Registration/RegistrationContainer";


const Registration = () => {
  return (
    <div className='page-body'>
        <RegistrationContainer/>
    </div>
  )
}

export default Registration;